module.exports = new __parcel__URL__("equalHousing.de668ec5.svg").toString();